import React from 'react'
import { Link } from 'react-router-dom'

const COMPANY = {
  name: '설계 EZ',
  representative: '가승호',
  address: '경기도 부천시 원미구 수도로 206번길 66-8, 3동 202호',
  bizNo: '555-46-01166',
  mailOrderNo: '2026-부천원미-1316',
  phone: '0505-007-8200',
  email: 'support@sgez.co.kr',
  contact: '전화 0505-007-8200, 이메일 support@sgez.co.kr 또는 서비스 내 고객문의(문의하기)',
}

export function TermsContent() {
  return (
    <div className="space-y-4 text-sm leading-relaxed text-slate-800">
      <h2 className="text-base font-semibold">제1조(목적)</h2>
      <p>
        본 이용약관(이하 “약관”)은 {COMPANY.name}(이하 “회사”)가 제공하는 설계 EZ 서비스(이하 “서비스”)의 이용과 관련하여 회사와
        이용자(이하 “회원”) 간의 권리·의무 및 책임사항, 이용조건 및 절차 등 기본사항을 규정함을 목적으로 합니다.
      </p>

      <h2 className="text-base font-semibold">제2조(정의)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>“서비스”란 회사가 제공하는 웹/앱 기반 기능 및 이에 부수하는 제반 서비스를 말합니다.</li>
        <li>“회원”이란 본 약관에 동의하고 회사가 정한 절차(가입 신청 및 승인 포함)에 따라 계정을 부여받은 자를 말합니다.</li>
        <li>“계정”이란 회원 식별 및 서비스 이용을 위해 회원에게 부여되는 이메일 등 식별정보와 인증수단(비밀번호, 소셜로그인 등)을 말합니다.</li>
        <li>“조직”이란 서비스 내 권한/좌석/구독의 관리 단위를 말합니다.</li>
        <li>“콘텐츠”란 회원 또는 회사가 서비스에서 제공·표시·저장·전송하는 정보(텍스트, 이미지, 파일 등 일체)를 말합니다.</li>
        <li>“유료서비스”란 회사가 별도의 대가를 받고 제공하는 서비스 또는 기능을 말합니다.</li>
        <li>“구독”이란 회원 또는 조직이 월/연 단위로 유료서비스를 이용하는 계약을 말합니다.</li>
        <li>
          “포인트”란 회원이 유상 또는 무상으로 부여/구매하여 서비스 내에서 특정 기능/상품에 사용할 수 있는 전산상 지급수단을 말합니다.
          포인트는 현금으로 환전되지 않으며, 본 약관 및 관련 정책에서 정한 범위 내에서만 사용됩니다.
        </li>
      </ul>

      <h2 className="text-base font-semibold">제3조(약관의 효력 및 변경)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>본 약관은 서비스 화면에 게시하거나 기타 방법으로 공지함으로써 효력이 발생합니다.</li>
        <li>회사는 관련 법령을 위반하지 않는 범위에서 약관을 변경할 수 있으며, 적용일자 및 변경사유를 명시하여 사전 공지합니다.</li>
        <li>회원에게 불리하거나 중요한 변경(유료조건, 권리·의무 등)은 적용일 30일 전부터, 그 외 변경은 적용일 7일 전부터 공지합니다.</li>
        <li>회원이 변경 약관 시행 이후에도 서비스를 계속 이용하는 경우 변경 약관에 동의한 것으로 봅니다. 회원은 동의하지 않을 경우 탈퇴할 수 있습니다.</li>
      </ul>

      <h2 className="text-base font-semibold">제4조(회원가입 및 계정관리)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>
          회원가입은 이용자가 약관 및 개인정보 처리방침에 동의하고 회사가 정한 절차에 따라 가입(신청/승인 포함)을 완료함으로써
          성립합니다.
        </li>
        <li>회사는 업무상·기술상 필요에 따라 가입 신청을 승인하거나 제한할 수 있습니다.</li>
        <li>만 14세 미만 아동은 회원가입을 할 수 없으며, 회사는 연령 확인 결과에 따라 가입 신청을 거절하거나 취소할 수 있습니다.</li>
        <li>회원은 계정 정보(비밀번호 포함)를 안전하게 관리할 책임이 있으며, 타인에게 공유/양도/대여할 수 없습니다.</li>
      </ul>

      <h2 className="text-base font-semibold">제5조(서비스의 제공 및 변경)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>회사는 안정적인 서비스 제공을 위해 서비스의 전부 또는 일부를 변경할 수 있습니다.</li>
        <li>중요한 변경 사항은 서비스 내 공지 등 합리적인 방법으로 사전 안내합니다.</li>
      </ul>

      <h2 className="text-base font-semibold">제6조(서비스의 중단)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>회사는 시스템 점검, 장애, 네트워크 문제 등 불가피한 경우 서비스 제공을 일시 중단할 수 있습니다.</li>
        <li>회사는 중단 사유 및 기간을 사전 공지하되, 긴급한 경우 사후 공지할 수 있습니다.</li>
      </ul>

      <h2 className="text-base font-semibold">제7조(회원의 의무 및 금지행위)</h2>
      <p>회원은 서비스 이용 시 관련 법령, 본 약관 및 회사의 운영정책을 준수하여야 하며, 다음 행위를 하여서는 안 됩니다.</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>타인의 계정/개인정보를 도용하거나 허위 정보를 등록하는 행위</li>
        <li>서비스의 정상 운영을 방해하거나 시스템을 침해하려는 행위</li>
        <li>자동화 도구를 이용한 무단 수집(스크래핑), 역공학, 무단 복제·배포 행위</li>
        <li>불법·유해 콘텐츠 게시/전송, 권리 침해(저작권/초상권/영업비밀 등) 행위</li>
        <li>회사 또는 제3자를 비방하거나 업무를 방해하는 행위</li>
      </ul>

      <h2 className="text-base font-semibold">제8조(콘텐츠의 권리)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>회원이 서비스에 저장/업로드한 콘텐츠의 권리는 원칙적으로 회원에게 귀속됩니다.</li>
        <li>회사는 서비스 제공을 위해 필요한 범위에서 콘텐츠를 저장·처리·전송할 수 있습니다.</li>
        <li>회사가 제공하는 서비스/소프트웨어/디자인 등 지식재산권은 회사 또는 정당한 권리자에게 귀속됩니다.</li>
      </ul>

      <h2 className="text-base font-semibold">제9조(진료정보분석 등 특화 기능)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>서비스는 진료·처방 등 데이터를 기반으로 분석/요약 정보를 제공할 수 있으며, 이는 의료행위가 아니며 참고 정보입니다.</li>
        <li>AI/OCR 등 자동화 기능의 결과는 참고용이며, 회사는 AI 기능 사용 사실을 사전에 고지하고 AI 생성 결과에는 AI 생성물 여부를 표시합니다.</li>
        <li>
          본 기능 제공 과정에서 건강정보(민감정보)가 처리될 수 있으며, 개인정보의 처리에 관한 상세는 개인정보 처리방침 및 별도 동의 문구에
          따릅니다.
        </li>
        <li>
          주민등록번호 등 고유식별정보는 법령상 근거가 확인된 업무에서만 처리하며, 해당 업무에서 필요한 경우 암호화하여
          저장할 수 있습니다. 법적 근거가 없으면 수집하지 않으며, 보유 목적이 끝나면 지체 없이 파기합니다.
        </li>
        <li>
          회원이 상담·진료정보분석·설문 등 업무를 수행하는 과정에서 입력되는 고객 정보는, 회원의 업무 편의를 위해 서비스 내
          “고객관리” 기능에서 최소 범위로 연계·조회될 수 있으며, 이는 의료행위가 아닙니다. 상세한 개인정보 처리 내용은 개인정보
          처리방침에 따릅니다.
        </li>
      </ul>

      <h2 className="text-base font-semibold">제10조(유료서비스: 구독/결제)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>회사는 월/연 구독 형태의 유료서비스를 제공할 수 있습니다.</li>
        <li>유료서비스의 구체 내용(요금, 제공 범위, 결제주기, 좌석/조직 기준 등)은 서비스 내 안내 또는 개별 계약에 따릅니다.</li>
        <li>개인회원의 앱 내 구독은 App Store 또는 Google Play에서 결제·갱신될 수 있으며, 해지·환불·결제수단 변경은 해당 스토어의 구독 관리 화면과 정책을 따릅니다.</li>
        <li>무료체험은 별도 결제 또는 스토어 구독 동의 없이 유료로 자동 전환되지 않습니다.</li>
        <li>구독료 인상, 결제주기 변경 등 중요한 유료 조건 변경은 서비스 화면, 스토어 결제창 또는 별도 안내를 통해 사전 고지 및 동의 절차를 거칩니다.</li>
        <li>앱 삭제 또는 서비스 탈퇴만으로 스토어 구독은 자동 해지되지 않습니다.</li>
        <li>
          정기결제(자동결제)가 설정된 경우, 회원이 해지하지 않는 한 결제주기마다 자동으로 결제될 수 있습니다. 해지는 서비스 내 설정 또는
          고객지원({COMPANY.contact})을 통해 신청할 수 있습니다.
        </li>
      </ul>

      <h2 className="text-base font-semibold">제11조(포인트)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>회사는 포인트를 유상 판매하거나 무상으로 제공할 수 있으며, 포인트의 사용처/가격/유효기간은 서비스 내 안내에 따릅니다.</li>
        <li>포인트는 원칙적으로 양도·대여·거래가 불가하며, 현금으로 환전되지 않습니다.</li>
        <li>유상 포인트의 유효기간은 구매일로부터 5년을 원칙으로 하되, 무상 포인트는 별도 유효기간이 적용될 수 있습니다.</li>
      </ul>

      <h2 className="text-base font-semibold">제12조(청약철회·환불·해지)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>
          유료서비스의 해지 및 환불은 관련 법령 및 회사의{' '}
          <Link to="/refund-policy" className="font-semibold text-brand-navy underline">
            청약철회·결제 취소 및 환불 정책
          </Link>
          (이하 “환불정책”)에 따릅니다. 환불정책은 서비스 웹사이트에 게시됩니다.
        </li>
        <li>환불정책에는 환불 가능/불가 요건, 산정 방식(일할계산 여부, 제공된 혜택 차감 등), 신청 방법/처리 기한이 포함됩니다.</li>
        <li>유료 기능에는 진료정보분석, 숨은보험금찾기, 설문/통합 리포트 AI, 진단시뮬레이션, 보험금청구, 사진 배경 제거와 같은 할당량형 기능뿐 아니라 고객등록, 계약·보험 정보 등록, 만기보험 등록, 명함생성, 리포트·자료 생성·저장·다운로드·공유 등 서비스 내 주요 기능 실행이 포함됩니다.</li>
        <li>유료 기능을 1회 이상 사용하거나 서비스 제공이 개시된 경우 환불정책에 따라 전액환불 및 부분환불이 제한될 수 있습니다.</li>
      </ul>

      <h2 className="text-base font-semibold">제13조(계약해지 및 이용제한)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>회원은 회사가 정한 방법으로 이용계약 해지를 요청할 수 있습니다. 다만 App Store 또는 Google Play에서 결제한 개인 구독은 별도로 스토어에서 직접 해지해야 합니다.</li>
        <li>회사는 회원이 본 약관을 위반한 경우 경고, 이용정지, 계약해지 등 조치를 할 수 있습니다.</li>
      </ul>

      <h2 className="text-base font-semibold">제14조(손해배상 및 면책)</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>
          회사는 고의 또는 중대한 과실이 없는 한 서비스 장애로 인한 손해에 대해 책임을 부담하지 않습니다(관련 법령이 허용하는 범위 내).
        </li>
        <li>회원의 귀책사유로 발생한 손해에 대해 회사는 책임을 지지 않습니다.</li>
      </ul>

      <h2 className="text-base font-semibold">제15조(분쟁해결 및 관할)</h2>
      <p>
        회사와 회원 간 분쟁이 발생한 경우, 관련 법령에 따라 성실히 협의하여 해결하며, 협의가 어려운 경우 관할 법원은 민사소송법 등
        관련 법령에 따릅니다.
      </p>

      <h2 className="text-base font-semibold">제16조(사업자 정보)</h2>
      <div className="rounded border bg-slate-50 p-3 text-sm">
        <div>상호: {COMPANY.name} (가라멜 스튜디오)</div>
        <div>대표자: {COMPANY.representative}</div>
        <div>사업자등록번호: {COMPANY.bizNo}</div>
        <div>통신판매업신고번호: {COMPANY.mailOrderNo}</div>
        <div>사업장 소재지: {COMPANY.address}</div>
        <div>전화: {COMPANY.phone}</div>
        <div>이메일: {COMPANY.email}</div>
      </div>

    </div>
  )
}

export function PrivacyContent() {
  return (
    <div className="space-y-4 text-sm leading-relaxed text-slate-800">
      <h2 className="text-base font-semibold">1. 개인정보의 처리 목적</h2>
      <p>회사는 다음 목적을 위해 개인정보를 처리합니다.</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>회원가입 신청 처리 및 승인, 계정 발급 및 관리</li>
        <li>서비스 제공, 기능 개선, 고객지원 및 민원 처리</li>
        <li>서비스 안정성 확보(보안, 이상행위 탐지, 로그 분석 등)</li>
        <li>법령상 의무 이행 및 분쟁 대응</li>
        <li>유료서비스 제공, 결제 처리, 요금 정산 및 환불 처리(해당 시)</li>
        <li>진료정보분석 서비스 제공(진료·처방 등 데이터 수집/분석/요약 제공)</li>
        <li>공개 랜딩(상담신청) 접수 및 상담 진행 지원(비회원 포함)</li>
        <li>
          회원(설계사 등)의 업무 지원: 서비스 내 고객관리 기능을 통한 고객 식별자·표시명 등 최소 정보의 연계, 진료정보분석·상담
          설문 등 서비스 이용 이력의 조회·정리(전화번호 평문은 원칙적으로 저장하지 않고 해시 등으로 처리)
        </li>
        <li>알림/메시지 발송(카카오/문자 등, 해당 기능 사용 시)</li>
      </ul>

      <h2 className="text-base font-semibold">2. 처리하는 개인정보 항목</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>
          <b>회원가입 신청/계정관리</b>: 이메일, 이름, 비밀번호(해시로 저장), 휴대폰번호, 소속 조직/역할, 생년월일(만 14세 확인 시 일시 처리 후 미저장), 연령 확인 방식·시각, 동의 이력(버전/시각/IP/UA 등)
        </li>
        <li>
          <b>소셜로그인 연동(이용자가 선택한 경우)</b>: Google·카카오·네이버 제공자 구분, 제공자 계정 식별자, 이메일, 이메일 확인 여부 및 연동 시각
        </li>
        <li>
          <b>서비스 이용 과정에서 자동 생성/수집</b>: 접속 로그, IP, 기기정보(브라우저 User-Agent), 쿠키/세션 식별자, 오류/이벤트 로그
        </li>
        <li>
          <b>앱 접근권한</b>: 필수 권한은 인터넷 연결이며, 선택 권한은 알림, 카메라, 사진/파일 선택입니다. 선택 권한은 해당 기능 사용 시 요청되며 거부해도 기본 서비스 이용은 가능합니다.
        </li>
        <li>
          <b>선택 동의</b>: 마케팅/광고성 정보 수신 동의 여부 및 동의 이력(버전/시각 등)
        </li>
        <li>
          <b>공개 랜딩(비회원 상담신청)</b>: 이름, 연락처, (선택)희망연락시간, (선택)문의내용, 동의 이력(문구/버전/시각 등)
        </li>
        <li>
          <b>유료서비스 결제/정산(해당 시)</b>: 거래 식별정보(승인번호 등), 결제일시, 결제금액, 상품/플랜 정보, 구매·환불 내역
          <div className="text-xs text-slate-500 mt-1">※ 카드번호 등 결제수단 정보는 결제대행사(PG)에서 처리되며, 회사는 원칙적으로 저장하지 않습니다.</div>
        </li>
        <li>
          <b>진료정보분석(민감정보 포함 가능)</b>: 진료내역, 처방/조제, 진단코드(KCD), 의료기관 관련 정보 등 분석·요약 제공에 필요한 범위의 정보
        </li>
        <li>
          <b>고유식별정보(주민등록번호) 처리 관련 안내</b>: 법령상 구체적인 처리 근거가 확인된 업무에 한해 최소 범위로 처리하며, 해당 기능에서는 암호화하여 저장할 수 있습니다. 법적 근거가 없으면 동의를 받더라도 수집하지 않으며, 보유 목적과 법정 보존기간이 끝나면 지체 없이 파기합니다.
        </li>
        <li>
          <b>고객관리(회원 업무용)</b>: 고객 표시명, 연락처(숫자형 원문) 및 중복 확인용 일방향 해시, (해당
          시) 생년월일·설문 세션 등과의 연결을 위한 식별자·이용 이력 메타데이터. 주민등록번호는 법령상 처리 근거가 확인된 업무가 아닌 일반 고객관리 목적으로 저장하지
          않는 것을 원칙으로 합니다.
        </li>
      </ul>

      <h2 className="text-base font-semibold">3. 개인정보의 보유 및 이용기간</h2>
      <p>
        회사는 원칙적으로 개인정보 처리 목적 달성 시 지체 없이 파기합니다. 다만 서비스 운영 및 보안, 분쟁 대응을 위해 아래 기준에 따라
        일정 기간 보관할 수 있습니다.
      </p>

      <div className="overflow-auto rounded border">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-700">
            <tr>
              <th className="text-left p-2 border-b">구분</th>
              <th className="text-left p-2 border-b">보관 항목(예시)</th>
              <th className="text-left p-2 border-b">보관 기간(기준)</th>
            </tr>
          </thead>
          <tbody className="text-slate-800">
            <tr>
              <td className="p-2 border-b">회원 계정</td>
              <td className="p-2 border-b">이메일, 이름, 비밀번호(해시), 휴대폰번호, 조직/역할</td>
              <td className="p-2 border-b">회원 자격 유지 기간</td>
            </tr>
            <tr>
              <td className="p-2 border-b">가입 신청</td>
              <td className="p-2 border-b">가입 신청 정보 및 동의 이력(버전/시각/IP/UA 등)</td>
              <td className="p-2 border-b">승인/거절 처리 후 1년(감사/분쟁 대응 목적)</td>
            </tr>
            <tr>
              <td className="p-2 border-b">동의 이력</td>
              <td className="p-2 border-b">약관/처리방침/마케팅 등 동의 여부 및 동의 이력</td>
              <td className="p-2 border-b">탈퇴 후 3년(분쟁 대응 목적)</td>
            </tr>
            <tr>
              <td className="p-2 border-b">서비스 이용 로그</td>
              <td className="p-2 border-b">접속기록, 요청 요약(TraceId 등), 오류/이벤트 로그</td>
              <td className="p-2 border-b">일반 로그 30일 / 오류 로그 180일</td>
            </tr>
            <tr>
              <td className="p-2 border-b">공개 랜딩(상담신청)</td>
              <td className="p-2 border-b">이름, 연락처, (선택)희망연락시간, (선택)문의내용, 동의 이력</td>
              <td className="p-2 border-b">접수일로부터 30일</td>
            </tr>
            <tr>
              <td className="p-2 border-b">고객관리(최소 프로필)</td>
              <td className="p-2 border-b">
                고객 표시명, 연락처(숫자형 원문) 및 중복 확인용 일방향 해시, (해당 시) 설문 세션·진료정보분석 결과와의 연결 식별자, 생성·수정 시각
              </td>
              <td className="p-2 border-b">회원 또는 소속 조직이 해당 고객의 업무를 수행하는 기간 또는 회원·고객의 삭제 요청 시까지</td>
            </tr>
            <tr>
              <td className="p-2 border-b">진료정보분석(raw)</td>
              <td className="p-2 border-b">수집된 원문 데이터(암호화 저장될 수 있음)</td>
              <td className="p-2 border-b">생성일로부터 최대 7일</td>
            </tr>
            <tr>
              <td className="p-2 border-b">진료정보분석(summary)</td>
              <td className="p-2 border-b">분석/요약 결과 데이터</td>
              <td className="p-2 border-b">생성일로부터 1년</td>
            </tr>
            <tr>
              <td className="p-2 border-b">결제/거래 기록(해당 시)</td>
              <td className="p-2 border-b">대금 결제 및 유료서비스 제공(구독/포인트) 관련 기록</td>
              <td className="p-2 border-b">5년</td>
            </tr>
            <tr>
              <td className="p-2 border-b">소비자 분쟁/불만 처리</td>
              <td className="p-2 border-b">고객 문의 및 분쟁 대응 기록</td>
              <td className="p-2 border-b">3년</td>
            </tr>
            <tr>
              <td className="p-2 border-b">표시·광고 기록</td>
              <td className="p-2 border-b">상품·서비스 표시 및 광고 내용, 발송 이력</td>
              <td className="p-2 border-b">6개월</td>
            </tr>
            <tr>
              <td className="p-2 border-b">첨부파일(의뢰)</td>
              <td className="p-2 border-b">의뢰 첨부 파일(스토리지 저장)</td>
              <td className="p-2 border-b">14일</td>
            </tr>
            <tr>
              <td className="p-2 border-b">첨부파일(공지)</td>
              <td className="p-2 border-b">공지 첨부 파일(스토리지 저장)</td>
              <td className="p-2 border-b">30일</td>
            </tr>
            <tr>
              <td className="p-2 border-b">미참조 파일</td>
              <td className="p-2 border-b">어떤 화면/레코드에도 연결되지 않은 업로드 파일</td>
              <td className="p-2 border-b">3일</td>
            </tr>
            <tr>
              <td className="p-2 border-b">삭제 처리된 파일</td>
              <td className="p-2 border-b">deleted_at이 기록된 파일</td>
              <td className="p-2 border-b">7일(물리 삭제 유예)</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p className="text-xs text-slate-500">
        위 기간은 운영 기준이며, 관련 법령 또는 개별 계약(조직 단위 계약 등)에 따라 달라질 수 있습니다.
      </p>

      <h2 className="text-base font-semibold">4. 개인정보의 파기절차 및 방법</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>파기 사유가 발생한 개인정보는 내부 방침 및 관련 법령에 따라 지체 없이 파기합니다.</li>
        <li>전자적 파일 형태: 복구 불가능한 방법으로 영구 삭제</li>
        <li>출력물 형태: 분쇄 또는 소각</li>
      </ul>

      <h2 className="text-base font-semibold">5. 개인정보의 제3자 제공</h2>
      <p>회사는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만 법령에 근거하거나 이용자의 동의가 있는 경우 예외로 합니다.</p>
      <div className="rounded border bg-slate-50 p-3 text-sm">
        <div className="font-semibold text-slate-800">공개 랜딩(상담신청) 제3자 제공(동의 기반)</div>
        <ul className="list-disc pl-5 mt-2 space-y-1 text-slate-700">
          <li>제공받는 자: 상담을 수행하는 회원(공개 페이지 소유자) 및 그 소속 조직(해당되는 경우)</li>
          <li>제공 항목: 이름, 연락처, (선택)희망연락시간, (선택)문의내용</li>
          <li>제공 목적: 상담 진행</li>
          <li>보유·이용기간: 접수일로부터 30일</li>
        </ul>
      </div>

      <h2 className="text-base font-semibold">6. 개인정보 처리의 위탁</h2>
      <p>
        회사는 서비스 이행을 위해 아래와 같이 개인정보 취급 업무를 외부 전문업체에 위탁하여 운영하고 있으며, 관련 법령에 따라 위탁 계약 시
        개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다.
      </p>
      <div className="overflow-auto rounded border">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-700">
            <tr>
              <th className="text-left p-2 border-b">수탁업체</th>
              <th className="text-left p-2 border-b">위탁업무의 내용</th>
              <th className="text-left p-2 border-b">위탁정보</th>
              <th className="text-left p-2 border-b">위탁기간</th>
            </tr>
          </thead>
          <tbody className="text-slate-800">
            <tr>
              <td className="p-2 border-b">Amazon Web Services, Inc.</td>
              <td className="p-2 border-b">클라우드 인프라(서버/DB/파일 저장소(S3) 등) 운영(기본 리전: 대한민국 서울)</td>
              <td className="p-2 border-b">서비스 운영 중 처리되는 개인정보 일체(저장/전송)</td>
              <td className="p-2 border-b">위탁 계약 종료 시까지</td>
            </tr>
            <tr>
              <td className="p-2 border-b">Google LLC (Firebase Cloud Messaging)</td>
              <td className="p-2 border-b">푸시 알림 전송</td>
              <td className="p-2 border-b">푸시 토큰, 알림 메시지 페이로드(최소 정보)</td>
              <td className="p-2 border-b">위탁 계약 종료 시까지</td>
            </tr>
            <tr>
              <td className="p-2 border-b">Apple Inc. / Google LLC (App Store / Google Play)</td>
              <td className="p-2 border-b">앱 내 구독 결제, 영수증 검증, 구독 상태 통지</td>
              <td className="p-2 border-b">스토어 계정 식별자, 상품 ID, 거래·영수증·구독 상태 정보</td>
              <td className="p-2 border-b">스토어 정책 및 위탁 계약 종료 시까지</td>
            </tr>
            <tr>
              <td className="p-2 border-b">(주)코리아포트원(PortOne, 결제 기능 개시 시)</td>
              <td className="p-2 border-b">결제 연동 서비스 제공</td>
              <td className="p-2 border-b">주문번호, 회원 식별값, 결제수단별 필요한 구매자 정보, 결제금액, 결제수단, 승인·취소·환불 결과 및 거래 식별정보</td>
              <td className="p-2 border-b">결제 기능 개시일부터 위탁 계약 종료 또는 관계 법령상 보존기간까지</td>
            </tr>
            <tr>
              <td className="p-2 border-b">(주)솔라피(Solapi) 등</td>
              <td className="p-2 border-b">알림톡/문자(SMS) 발송 대행(해당 기능 사용 시)</td>
              <td className="p-2 border-b">휴대폰번호, 발송 메시지(최소 정보)</td>
              <td className="p-2 border-b">발송 목적 달성 시까지</td>
            </tr>
            <tr>
              <td className="p-2 border-b">OpenAI, L.L.C.</td>
              <td className="p-2 border-b">AI 기반 텍스트·이미지 생성 및 분석</td>
              <td className="p-2 border-b">이용자가 선택한 프롬프트, 입력 파일·이미지, 생성 결과 및 서비스 메타데이터</td>
              <td className="p-2 border-b">처리 목적 달성 또는 공급자 정책·계약상 보존기간까지</td>
            </tr>
            <tr>
              <td className="p-2 border-b">Google LLC (Gemini API)</td>
              <td className="p-2 border-b">AI 기반 텍스트·이미지 생성 및 분석</td>
              <td className="p-2 border-b">이용자가 선택한 프롬프트, 입력 파일·이미지, 생성 결과 및 서비스 메타데이터</td>
              <td className="p-2 border-b">처리 목적 달성 또는 공급자 정책·계약상 보존기간까지</td>
            </tr>
            <tr>
              <td className="p-2 border-b">Photoroom SAS (PhotoRoom API, 기능 사용 시)</td>
              <td className="p-2 border-b">프로필·리포트용 인물 이미지 배경 제거</td>
              <td className="p-2 border-b">이용자가 선택한 인물 사진·이미지 및 처리 메타데이터</td>
              <td className="p-2 border-b">API 처리 완료 또는 공급자 정책·위탁 계약상 보존기간까지</td>
            </tr>
            <tr>
              <td className="p-2 border-b">Canva Austria GmbH (remove.bg API, 기능 사용 시)</td>
              <td className="p-2 border-b">프로필·리포트용 인물 이미지 배경 제거</td>
              <td className="p-2 border-b">이용자가 선택한 인물 사진·이미지 및 처리 메타데이터</td>
              <td className="p-2 border-b">API 처리 완료 또는 공급자 정책·위탁 계약상 보존기간까지</td>
            </tr>
            <tr>
              <td className="p-2 border-b">Upstage Co., Ltd.</td>
              <td className="p-2 border-b">문서 OCR 및 구조화 정보 추출</td>
              <td className="p-2 border-b">이용자가 OCR 처리를 요청한 문서·이미지 및 추출 결과</td>
              <td className="p-2 border-b">처리 목적 달성 또는 위탁 계약 종료 시까지</td>
            </tr>
            <tr>
              <td className="p-2 border-b">(주)링크허브(Popbill)</td>
              <td className="p-2 border-b">문자·팩스 발송, 전송 결과 확인 및 관련 업무 처리</td>
              <td className="p-2 border-b">휴대폰번호, 팩스번호, 발송 내용·첨부문서 및 전송 메타데이터</td>
              <td className="p-2 border-b">발송 목적 달성 또는 관계 법령·위탁 계약상 보존기간까지</td>
            </tr>
            <tr>
              <td className="p-2 border-b">(주)헥토데이터</td>
              <td className="p-2 border-b">
                <div>- 신용정보주체의 인증 정보를 이용하여 개인(신용)정보를 중계하는 업무</div>
                <div>
                  - API 서비스 품질향상 및 업무 대응을 위해 신용정보주체 인증 정보를 통한 요청/응답 데이터 저장 업무(위탁 계약 종료 시 일괄 삭제)
                </div>
                <div>- 정보주체의 개인정보 열람, 정정·삭제, 처리 정지 요청 등을 처리</div>
              </td>
              <td className="p-2 border-b">
                <div>- 개인(신용)정보</div>
                <div>- 요청/응답 데이터 일체</div>
                <div>- 기업정보</div>
              </td>
              <td className="p-2 border-b">위탁 계약 종료 시까지</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p className="text-xs text-slate-500">
        ※ 현재 PG사 계약 및 결제 기능은 준비 단계로, 결제 기능 개시 전까지 포트원과 PG사에 결제 관련 개인정보를 처리 위탁하지 않습니다. 실제 계약 PG사명과 결제수단별 위탁 범위는 결제 기능 개시 전에 본 방침에 반영합니다.
      </p>

      <h2 className="text-base font-semibold">6-1. 개인정보의 국외 이전</h2>
      <p>
        회사는 이용자가 요청한 AI·푸시 알림·앱 구독 기능을 제공하기 위해 개인정보보호법 제28조의8에 따른 적법한 근거를 확인하고
        아래와 같이 개인정보를 국외로 이전할 수 있습니다.
      </p>
      <div className="overflow-auto rounded border">
        <table className="w-full min-w-[980px] text-sm">
          <thead className="bg-slate-50 text-slate-700">
            <tr>
              <th className="text-left p-2 border-b">이전받는 자·연락처</th>
              <th className="text-left p-2 border-b">국가</th>
              <th className="text-left p-2 border-b">이전 항목</th>
              <th className="text-left p-2 border-b">목적</th>
              <th className="text-left p-2 border-b">시점·방법</th>
              <th className="text-left p-2 border-b">보유·이용기간</th>
            </tr>
          </thead>
          <tbody className="text-slate-800">
            <tr>
              <td className="p-2 border-b">OpenAI, L.L.C. (privacy.openai.com)</td>
              <td className="p-2 border-b">미국</td>
              <td className="p-2 border-b">프롬프트, 입력 파일·이미지, 생성 결과, 기술 메타데이터</td>
              <td className="p-2 border-b">AI 텍스트·이미지 생성 및 분석</td>
              <td className="p-2 border-b">AI 기능 요청 시 암호화된 네트워크로 전송</td>
              <td className="p-2 border-b">기본 남용방지 로그 최대 30일. 별도 ZDR 설정·계약 또는 법령에 따라 달라질 수 있음</td>
            </tr>
            <tr>
              <td className="p-2 border-b">Google LLC, Gemini API (support.google.com/policies)</td>
              <td className="p-2 border-b">미국 및 Google 처리시설 소재 국가</td>
              <td className="p-2 border-b">프롬프트, 입력 파일·이미지, 생성 결과, 기술 메타데이터</td>
              <td className="p-2 border-b">AI 텍스트·이미지 생성 및 분석</td>
              <td className="p-2 border-b">AI 기능 요청 시 암호화된 네트워크로 전송</td>
              <td className="p-2 border-b">유료 API 남용방지 목적의 제한된 기간. 검색 Grounding 사용 시 30일, 인메모리 캐시는 최대 24시간</td>
            </tr>
            <tr>
              <td className="p-2 border-b">Photoroom SAS, PhotoRoom API (photoroom.com/legal/privacy)</td>
              <td className="p-2 border-b">프랑스 및 하위처리자 처리시설 소재 국가</td>
              <td className="p-2 border-b">이용자가 선택한 인물 사진·이미지 및 처리 메타데이터</td>
              <td className="p-2 border-b">프로필·리포트용 이미지 배경 제거</td>
              <td className="p-2 border-b">해당 기능 요청 시 암호화된 네트워크로 전송</td>
              <td className="p-2 border-b">API 처리 완료 또는 공급자 정책·계약상 보존기간까지</td>
            </tr>
            <tr>
              <td className="p-2 border-b">Canva Austria GmbH, remove.bg API (remove.bg/privacy)</td>
              <td className="p-2 border-b">오스트리아 및 처리시설 소재 국가</td>
              <td className="p-2 border-b">이용자가 선택한 인물 사진·이미지 및 처리 메타데이터</td>
              <td className="p-2 border-b">프로필·리포트용 이미지 배경 제거</td>
              <td className="p-2 border-b">해당 기능 요청 시 암호화된 네트워크로 전송</td>
              <td className="p-2 border-b">API 호출 처리 직후 삭제(공급자 정책·법령상 예외에 따라 달라질 수 있음)</td>
            </tr>
            <tr>
              <td className="p-2 border-b">Google LLC, Google Sign-In (policies.google.com)</td>
              <td className="p-2 border-b">미국 및 Google 처리시설 소재 국가</td>
              <td className="p-2 border-b">Google ID 토큰, 계정 식별자·이메일 확인 정보, 기술 메타데이터</td>
              <td className="p-2 border-b">이용자가 선택한 Google 로그인·계정 연동의 본인 확인</td>
              <td className="p-2 border-b">로그인 또는 계정 연동 요청 시 암호화된 네트워크로 전송</td>
              <td className="p-2 border-b">인증 처리 완료 또는 Google 정책·법령상 보존기간까지</td>
            </tr>
            <tr>
              <td className="p-2 border-b">Google LLC, Firebase Cloud Messaging (support.google.com/policies)</td>
              <td className="p-2 border-b">미국 및 Google 처리시설 소재 국가</td>
              <td className="p-2 border-b">푸시 토큰, 알림 메시지 페이로드</td>
              <td className="p-2 border-b">앱 푸시 알림 전송</td>
              <td className="p-2 border-b">알림 발송 시 암호화된 네트워크로 전송</td>
              <td className="p-2 border-b">서비스 제공 기간 또는 토큰 삭제·무효화 시까지</td>
            </tr>
            <tr>
              <td className="p-2 border-b">Apple Inc. / Google LLC (apple.com/privacy, policies.google.com)</td>
              <td className="p-2 border-b">미국 및 각 사업자의 처리시설 소재 국가</td>
              <td className="p-2 border-b">스토어 계정·상품 식별자, 거래·영수증·구독 상태 정보</td>
              <td className="p-2 border-b">앱 구독 결제, 영수증 검증 및 구독 상태 관리</td>
              <td className="p-2 border-b">결제·검증·구독 상태 확인 시 암호화된 네트워크로 전송</td>
              <td className="p-2 border-b">스토어 정책, 계약 및 관계 법령에 따른 기간</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p className="text-xs text-slate-500">
        이용자는 해당 기능을 사용하지 않거나 고객지원({COMPANY.contact})을 통해 국외 이전을 거부할 수 있습니다. 거부하면 AI 생성,
        앱 푸시 또는 스토어 구독 등 해당 기능의 제공이 제한될 수 있으나 그 밖의 기본 서비스는 이용할 수 있습니다.
      </p>

      <h2 className="text-base font-semibold">7. 정보주체의 권리·의무 및 행사방법</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>이용자는 개인정보 열람/정정/삭제/처리정지 요구 등 권리를 행사할 수 있습니다.</li>
        <li>권리 행사는 서비스 내 기능 또는 고객지원({COMPANY.contact})을 통해 요청할 수 있습니다.</li>
      </ul>

      <h2 className="text-base font-semibold">8. 개인정보의 안전성 확보조치</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>비밀번호 등 인증정보는 안전한 방식(해시 등)으로 처리</li>
        <li>민감정보(진료 원문 등)는 필요 시 암호화하여 저장</li>
        <li>접근권한 관리, 접근통제, 보안 업데이트, 로그 점검 등</li>
      </ul>

      <h2 className="text-base font-semibold">9. 쿠키의 사용</h2>
      <p>회사는 서비스 제공을 위해 쿠키를 사용할 수 있으며, 이용자는 브라우저 설정을 통해 쿠키 저장을 거부할 수 있습니다.</p>

      <h2 className="text-base font-semibold">9-1. 마케팅/광고성 정보 수신 동의의 철회</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li>이용자는 언제든지 마케팅/광고성 정보 수신 동의를 철회할 수 있습니다.</li>
        <li>철회 방법: 고객지원({COMPANY.contact})로 “수신거부/철회 요청”을 접수</li>
      </ul>

      <h2 className="text-base font-semibold">10. 개인정보 보호책임자</h2>
      <div className="rounded border bg-slate-50 p-3 text-sm">
        <div>상호: {COMPANY.name}</div>
        <div>대표자: {COMPANY.representative}</div>
        <div>개인정보 보호책임자: {COMPANY.representative}(대표)</div>
        <div>주소: {COMPANY.address}</div>
        <div>사업자등록번호: {COMPANY.bizNo}</div>
        <div>통신판매업신고번호: {COMPANY.mailOrderNo}</div>
        <div>전화: {COMPANY.phone}</div>
        <div>이메일: {COMPANY.email}</div>
      </div>

      <h2 className="text-base font-semibold">11. 고지의 의무</h2>
      <p>본 방침의 내용 추가·삭제 및 수정이 있을 경우, 시행일 최소 7일 전(중요 변경은 30일 전)부터 공지합니다.</p>

    </div>
  )
}

